// Module
var code = "<react-component name=\"TemplatesList\"></react-component>\n";
// Exports
module.exports = code;